
import { defineComponent, ref, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  setup() {
    let examId = ref("");

    const router = useRouter();
    const route = useRoute();
    const goBack = () => {
      router.push({
        path: "/examPaperList",
      });
    };
    const goToExam = () => {
      router.push({
        path: "/paper",
      });
    };
    onBeforeMount(() => {
      console.log("route", route.query);
      examId.value = (route.query as any).examId;
    });
    return {
      examId,
      goBack,
      goToExam,
    };
  },
});
